// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IHealthPlanEnrollmentSummaryRecordDto } from './IHealthPlanEnrollmentSummaryRecordDto';
import {
    IHealthPlanEnrollmentSummaryRecordDtoFromJSON,
    IHealthPlanEnrollmentSummaryRecordDtoFromJSONTyped,
    IHealthPlanEnrollmentSummaryRecordDtoToJSON,
    IHealthPlanEnrollmentSummaryRecordDtoToJSONTyped,
} from './IHealthPlanEnrollmentSummaryRecordDto';

/**
 * 
 * @export
 * @interface IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto
 */
export interface IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto
     */
    subsidiary_name?: string;
    /**
     * 
     * @type {Array<IHealthPlanEnrollmentSummaryRecordDto>}
     * @memberof IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto
     */
    subsidiary_records?: Array<IHealthPlanEnrollmentSummaryRecordDto>;
}

/**
 * Check if a given object implements the IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto interface.
 */
export function instanceOfIReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto(value: object): value is IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto {
    return true;
}

export function IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDtoFromJSON(json: any): IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto {
    return IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDtoFromJSONTyped(json, false);
}

export function IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiary_name': json['subsidiary_name'] == null ? undefined : json['subsidiary_name'],
        'subsidiary_records': json['subsidiary_records'] == null ? undefined : ((json['subsidiary_records'] as Array<any>).map(IHealthPlanEnrollmentSummaryRecordDtoFromJSON)),
    };
}

export function IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDtoToJSON(json: any): IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto {
    return IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDtoToJSONTyped(json, false);
}

export function IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDtoToJSONTyped(value?: IReportSummaryGroupDtoHealthPlanEnrollmentSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subsidiary_name': value['subsidiary_name'],
        'subsidiary_records': value['subsidiary_records'] == null ? undefined : ((value['subsidiary_records'] as Array<any>).map(IHealthPlanEnrollmentSummaryRecordDtoToJSON)),
    };
}

